import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { initGA } from "@/lib/ga";
import { MyAuthProvider } from "../contexts/MyAuthContext";
import { CartProvider } from "../contexts/CartContext";

/**
 * Wrapper público para páginas que podem ser usadas sem autenticação
 * (ex: catálogo /loja). Fornece os contexts necessários mas sem
 * MyLayout (sidebar/header do portal de cliente).
 */
export default function PublicShopLayout() {
  useEffect(() => { initGA(); }, []);
  return (
    <MyAuthProvider>
      <CartProvider>
        <div className="min-h-screen bg-[#FAF8F2]">
          <main className="max-w-7xl mx-auto px-4 lg:px-8 py-6">
            <Outlet />
          </main>
        </div>
      </CartProvider>
    </MyAuthProvider>
  );
}
